
export const FORMAT = "D-M-YYYY";

export const LPER = "20\u1d57\u02b0 percentile";
export const HPER = "80\u1d57\u02b0 percentile";
export const MEDIAN = "Median";

export const LOW = "Low";
export const MEDIUM = "Medium";
export const HIGH = "High";
export const PRECIP = "Precipitation";
export const CL = "Cloud Level";

export const SELF = "self";



